import { api } from '../../../lib/api'

export const GET_MESSAGES_REQUEST = 'GET_MESSAGES_REQUEST'
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS'
export const GET_MESSAGES_FAILED = 'GET_MESSAGES_FAILED'

export const getMessages = function () {
  return function (dispatch) {
    dispatch({
      type: GET_MESSAGES_REQUEST
    })
    api.getMessages().then(getMessagesResponse => {
      dispatch({
        type: GET_MESSAGES_SUCCESS,
        payload: getMessagesResponse
      })

    }).catch(error => {
      dispatch({
        type: GET_MESSAGES_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/message/get-messages.js